import { PaywallProps } from '@components/Paywall';
import { paywall_params_api_article_path, share_url_api_article_path } from '@routes';

import request from './request';

export const ARTICLE_SHARE_KEY = 'article_share';
export const ARTICLE_PAYWALL_PROPS_KEY = 'article_paywall_props';

export interface ArticleShareResponse {
  canShareArticle: boolean;
  escapedArticleTitle: string;
  escapedGoLink: string;
  shareUrl: string;
}

export interface ArticlePaywallPropsResponse {
  articleId: number;
  paywallProps: PaywallProps;
}

export async function getArticleShareLink({
  articleId,
}: {
  articleId: number;
}): Promise<ArticleShareResponse> {
  const resp = await request('get', share_url_api_article_path(articleId));
  return resp;
}

export async function getArticlePaywallProps({
  articleId,
  offerCode,
}: {
  articleId: number;
  offerCode: string;
}): Promise<ArticlePaywallPropsResponse> {
  const resp = await request(
    'get',
    paywall_params_api_article_path(articleId, { offer: offerCode })
  );
  return resp;
}
